/** @jsx jsx */
import { navigate } from 'gatsby';
import { RichText } from 'prismic-reactjs';
import { Box, Button, jsx } from 'theme-ui';
import { IoMdArrowForward } from 'react-icons/io';
import styles from './home-banner.style';
import bannerImg from '../../images/home-banner.png';

const HomeBanner = (props: any) => {
	const { banner, bannerTitle, bannerSubTitle, bannerButtonText } = props;
	return (
		<Box
			as="section"
			sx={{
				backgroundImage: `url(${
					banner && banner.url ? banner.url : bannerImg
				})`,
				...styles.banner,
			}}
		>
			<Box as="header" sx={styles.bannerContent}>
				<h1>{RichText.render(bannerTitle)}</h1>
				{RichText.render(bannerSubTitle)}
				<Button variant="white" onClick={() => navigate('#feature')}>
					{bannerButtonText ? RichText.asText(bannerButtonText) : 'Order Now'}
					<IoMdArrowForward />
				</Button>
			</Box>
		</Box>
	);
};

export default HomeBanner;
